import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { EStatus } from '../models/types.enum';

@Injectable({
  providedIn: 'root'
})
export class FormUtils {

  constructor() {}

  handleConditionChange(control: AbstractControl, shouldBeEnabled: boolean) {
    if (shouldBeEnabled) {
      control.enable();
      control.setValidators([Validators.required]);
    } else {
      control.disable();
      control.setValue(null);
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  minSelectedCheckboxes(min = 1): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // only use this validator with FormArray instances
      if (control instanceof FormArray) {
        const totalSelected = control.controls
          .map(control => control.value)
          .reduce((prev, next) => next ? prev + 1 : prev, 0);
  
        return totalSelected >= min ? null : { required: true };
      }
      return null;
    };
  }

  parentAndDependenciesValidator(yesValue: string): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const parentControl = formGroup.get('parentCheckbox'); // The parent checkbox
      const dependencyControls = Object.keys(((formGroup as FormGroup)).controls)
        .filter(key => key !== 'parentCheckbox')
        .map(key => formGroup.get(key));
  
      const parentChecked = parentControl?.value === yesValue;
  
      let isAtLeastOneDependencyChecked = false;
  
      // Check if at least one dependency checkbox is checked
      dependencyControls.forEach(control => {
        if (control?.value === yesValue) {
          isAtLeastOneDependencyChecked = true;
        }
      });
  
      // If the parent is checked, but no dependencies are checked, return an error
      if (parentChecked && !isAtLeastOneDependencyChecked) {
        return { 'noDependenciesChecked': true };
      }
  
      return null; // Validation passed
    };
  }

  // atLeastOneCheckboxCheckedValidator(yesValue: string): ValidatorFn {
  //   return (formGroup: FormGroup) => {
  //     let oneChecked = false;
  //     Object.keys(formGroup.controls).forEach(key => {
  //       const control = formGroup.get(key);
  //       if (!control || control.value !== yesValue) {
  //         return;
  //       }
  //       if (control.value === yesValue) {
  //         oneChecked = true;
  //       }
  //     });
  //     return oneChecked
  //   };
  // }
  
  convertBooleanToNumber(value: boolean): string {
    return value ? '1' : '0';
  }

  getTooltipContent(fieldValue: number, context: string): string {
    if (context === 'Threat Assessment Team') {
      switch (fieldValue) {
        case EStatus.FormUndone:
          return 'Missing ' + context;
        case EStatus.FormDone:
          return context + ' is assigned';
        default:
          return 'Threat Assessment Team status unknown';
      }
    } else {
      switch (fieldValue) {
        case EStatus.FormUndone:
          return context;
        case EStatus.FormDone:
          return context + " is completed and hasn't been reviewed";
        case EStatus.ReviewPending:
          return context + ' Review is pending';
        case EStatus.ReviewComplete:
          return context + ' Review is completed';
        default:
          return 'Status unknown';  // Default message
      }
    }
  }
}
